import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import CachedIcon from '@mui/icons-material/Cached';
import Button from '@mui/material/Button';
import useCustomData from '../../../context/useCustomData';
import { Alert, AlertTitle } from '@mui/material';

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const RotatingIcon = styled(CachedIcon)`
  animation: ${rotateAnimation} 1s linear infinite;
`;

const NavBar = () => {
  const { refresh, isLoading } = useCustomData();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const Title = styled(Typography)({
    fontWeight: 'bold',
    marginLeft: '20px',
  });

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleInsWeb= () => {
    setAnchorEl(null);
  };

  const handleRefresh = () => {
    refresh();
  };

  return (
    <AppBar position="sticky">
      <Toolbar style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" component="div">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Title variant="h6">
                <span role="img" aria-label="React logo">
                  ⚙️
                </span>
                ClassfiWeb
              </Title>
            </div>
          </Typography>
        </div>
        <div>
          <Button
            variant="contained"
            color="success"
            size="small"
            onClick={handleRefresh}
          >
            {isLoading ? (
              <RotatingIcon />
            ) : (
              <CachedIcon />
            )}
          </Button>
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleInsWeb}>
              Importar horario de InsWeb
              <Typography variant="caption" color="textSecondary" align="center">
                (EN DESARROLLO)
              </Typography>
            </MenuItem>

          </Menu>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;

